"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const faCheck_1 = require("@fortawesome/pro-light-svg-icons/faCheck");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const CheckedListItem = ({ children, className, isChecked = false }) => {
    const classes = (0, classnames_1.default)('_d-flex _justify-content-between', className);
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes, children: [children, isChecked && (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faCheck_1.faCheck })] }));
};
exports.default = CheckedListItem;
